import React from 'react';

import moment from 'moment';

import { COEChangeRequest } from '../../declarations';
import { centsToCurrencyString } from '../../helpers/formatUtils';
import LabeledRow from '../common/SectionCard/LabeledRow';
import SectionCard from '../common/SectionCard/SectionCard';
import SectionCardContent from '../common/SectionCard/SectionCardContent';
import SellerStatus from './SellerStatus';

import './TransactionFactsSectionStyle.less';

export interface ITransactionFactsSectionProps {
  changeClosingDateRequest?: COEChangeRequest;
  closeOfEscrowDate: string;
  earnestDepositCents: number;
  openChangeClosingDateModal?: () => void;
  pendingDate: string;
}

export default class TransactionFactsSection extends React.PureComponent<
  ITransactionFactsSectionProps
> {
  public render(): JSX.Element {
    const {
      closeOfEscrowDate,
      earnestDepositCents,
      // openChangeClosingDateModal,
      pendingDate,
    } = this.props;

    const pendingDateString = pendingDate ? moment(pendingDate).format('MMMM D, YYYY') : '-';
    const closeOfEscrowString = moment(closeOfEscrowDate).format('MMMM D, YYYY');
    const earnestDepositString = earnestDepositCents
      ? centsToCurrencyString(earnestDepositCents)
      : '-';

    return (
      <SectionCard
        className="resale-closing-dashboard-transaction-facts-section"
        headerText="Transaction Summary"
        id="facts-section"
      >
        <SectionCardContent>
          <LabeledRow label="Contract Accept Date">{pendingDateString}</LabeledRow>
          <LabeledRow label="Closing Date">
            <div className="closing-date-row-content">
              {closeOfEscrowString}
              {this.maybeDisplayAcceptedRequestStatus()}
            </div>
          </LabeledRow>
          {this.maybeDisplayPendingRequest()}
          {/* <LabeledRow label="">
            <button className="button secondary" onClick={openChangeClosingDateModal}>
              Request change
            </button>
          </LabeledRow> */}
          <LabeledRow label="Earnest Money Deposit">{earnestDepositString}</LabeledRow>
        </SectionCardContent>
      </SectionCard>
    );
  }

  private maybeDisplayAcceptedRequestStatus = () => {
    const { changeClosingDateRequest } = this.props;
    if (changeClosingDateRequest && changeClosingDateRequest.state === 'accepted') {
      return (
        <div className="request-status">
          <SellerStatus statusText="Seller Approved" type="approved" />
        </div>
      );
    }
  };

  private maybeDisplayPendingRequest = () => {
    const { changeClosingDateRequest } = this.props;
    if (changeClosingDateRequest && changeClosingDateRequest.state === 'active') {
      return (
        <LabeledRow label="Requested Closing Date">
          <div className="request-closing-date-row-content">
            {moment(changeClosingDateRequest.request_metadata['new_date']).format('MMMM D, YYYY')}
            <div className="request-status">
              <SellerStatus statusText="Seller Review Pending" type="pending" />
            </div>
          </div>
        </LabeledRow>
      );
    }
  };
}
